var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTeleponCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.500488,
    y: 0.560059,
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.50049 9.0216C5.50049 15.3941 10.6664 20.5601 17.0389 20.5601H18.7697C19.7256 20.5601 20.5005 19.7852 20.5005 18.8293V17.7742C20.5005 17.3771 20.2302 17.031 19.845 16.9346L16.4425 16.084C16.1048 15.9996 15.7493 16.1258 15.5403 16.4044L14.794 17.3994C14.5774 17.6882 14.2028 17.816 13.8638 17.6918C11.32 16.7599 9.30061 14.7405 8.36877 12.1967C8.24459 11.8577 8.3723 11.4831 8.66111 11.2665L9.6562 10.5202C9.93474 10.3113 10.061 9.95579 9.97651 9.61801L9.1259 6.21556C9.02959 5.83032 8.68345 5.56006 8.28635 5.56006H7.23126C6.27538 5.56006 5.50049 6.33495 5.50049 7.29083V9.0216Z",
    stroke: "#2A9DF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTeleponCircle);
export default __webpack_public_path__ + "static/media/ic-telepon-circle.fd8392c7ef21b6f0dd8c19ddc72a0a9d.svg";
export { ForwardRef as ReactComponent };